// P24 — single state store for role lens, module view and filters (persisted under one key).
import { useSyncExternalStore } from "react";
import { getRole } from "@/lib/roles";
import { visibleIds } from "@/components/Sidebar";

const KEY = "hcp_lens";

const migrate = () => {
  let filters = {};
  try { filters = JSON.parse(localStorage.getItem("hcp_filters")) || {}; } catch { /* ignore */ }
  return { roleId: localStorage.getItem("hcp_role") || "leadership", view: "dashboard", filters, functionFilter: "all" };
};

let state = (() => {
  try {
    const s = JSON.parse(localStorage.getItem(KEY));
    if (s && s.roleId) return { view: "dashboard", filters: {}, functionFilter: "all", ...s };
  } catch { /* ignore */ }
  return migrate();
})();

// stale view from a previous role is auto-corrected on load
if (state.view !== "ai" && !visibleIds(getRole(state.roleId)).includes(state.view)) {
  state = { ...state, view: "dashboard" };
}

const listeners = new Set();
const emit = () => {
  localStorage.setItem(KEY, JSON.stringify(state));
  listeners.forEach((l) => l());
};

export const lensStore = {
  get: () => state,
  subscribe: (l) => { listeners.add(l); return () => listeners.delete(l); },
  setView: (view) => { state = { ...state, view }; emit(); },
  setFilters: (updater) => {
    const filters = typeof updater === "function" ? updater(state.filters) : updater;
    state = { ...state, filters }; emit();
  },
  setFunctionFilter: (functionFilter) => { state = { ...state, functionFilter }; emit(); },
  // Role change through ONE store: auto-clears incompatible stale filters and returns what was cleared.
  setRole: (roleId) => {
    const r = getRole(roleId);
    const cleared = [];
    let { view, functionFilter } = state;
    if (view !== "ai" && !visibleIds(r).includes(view)) {
      cleared.push(`module "${view}" (not available to this role)`);
      view = "dashboard";
    }
    if (functionFilter !== "all" && !(r.implicationFunctions || []).includes(functionFilter)) {
      cleared.push(`function filter "${functionFilter}" (outside this role's functions)`);
      functionFilter = "all";
    }
    state = { ...state, roleId, view, functionFilter };
    emit();
    return cleared;
  },
};

export const useLens = () => useSyncExternalStore(lensStore.subscribe, lensStore.get);
